/** Language switcher (mk/sq/en) — topbar dropdown (Radix). */
import * as Dropdown from '@radix-ui/react-dropdown-menu';
import { Check, Languages } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from './cn.js';

const LOCALES: { code: 'mk' | 'sq' | 'en'; label: string; short: string }[] = [
  { code: 'mk', label: 'Македонски', short: 'MK' },
  { code: 'sq', label: 'Shqip', short: 'SQ' },
  { code: 'en', label: 'English', short: 'EN' },
];

export function LocaleSwitcher(): ReactNode {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) ?? 'mk';
  const active = LOCALES.find((l) => l.code === current) ?? LOCALES[0]!;

  return (
    <Dropdown.Root>
      <Dropdown.Trigger
        aria-label="Language"
        className="inline-flex h-9 cursor-pointer items-center gap-1.5 rounded-lg border border-border px-2.5 text-sm font-medium text-muted transition-colors hover:bg-surface-2 hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
      >
        <Languages className="h-4 w-4" aria-hidden />
        {active.short}
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          align="end"
          sideOffset={6}
          className="z-50 min-w-[10rem] rounded-xl border border-border bg-surface p-1 shadow-pop data-[state=open]:animate-fade-in"
        >
          {LOCALES.map((l) => (
            <Dropdown.Item
              key={l.code}
              onSelect={() => void i18n.changeLanguage(l.code)}
              className={cn(
                'flex cursor-pointer items-center justify-between gap-2 rounded-lg px-2.5 py-2 text-sm outline-none',
                'text-fg data-[highlighted]:bg-surface-2',
              )}
            >
              {l.label}
              {l.code === current ? <Check className="h-4 w-4 text-primary" aria-hidden /> : null}
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
}
